import type { MapStateToPropsFactory } from 'react-redux';
import { connect } from 'react-redux';
import { makeGetDlpOrderValidationErrors } from 'state/secondaryMarket/dlpOrder/dlpOrder.selectors';
import type { DlpOrderFormModel } from 'state/secondaryMarket/dlpOrder/form/dlpOrderForm.model';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
  className?: string;
}>;

type StateProps = Readonly<{
  validationErrors: readonly SecondaryMarketFormError<DlpOrderFormModel>[];
  backendReports: readonly SecondaryMarketFormError<DlpOrderFormModel>[];
}>;

export type NotReadySidePanelProps = OwnProps & StateProps;

const backendReports: readonly SecondaryMarketFormError<DlpOrderFormModel>[] = [];

const mapStateToProps: MapStateToPropsFactory<StateProps, OwnProps, AppState> = () => {
  const getValidationErrors = makeGetDlpOrderValidationErrors();

  return (state: AppState, { tabId }: OwnProps): StateProps => {
    const validationErrors: SecondaryMarketFormError<DlpOrderFormModel>[] = getValidationErrors(state, tabId);

    return {
      validationErrors,
      backendReports,
    };
  };
};

export const connectNotReadySidePanel = connect(mapStateToProps);
